import type IsDebugCheckerInterface from './IsDebugCheckerInterface';

export default class IsDebugChecker implements IsDebugCheckerInterface {
  public isDebug(): boolean {
    // TODO: использовать import.meta.env
    // eslint-disable-next-line node/prefer-global/process
    return process.env.NODE_ENV !== 'production';
  }
}
